import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import BaseEditor from './baseEditor'
import Button from 'components/button'
import ContactListSearcher from 'containers/contactListSearcher'
import './inlineEditor.scss'

const getClassName = prefix('inlineEditor-contactListEditor-')

class ContactListEditor extends Component {
  state = {
    value: this.props.value,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({value: nextProps.value})
    }
  }

  none = () => {
    const {onCommit} = this.props
    this.setState({value: null})
    onCommit(null)
  }

  change = (newValue, selected) => {
    const {multiSelect} = this.props

    if (multiSelect) {
      let {value} = this.state
      if (value === null) value = []

      if (selected) {
        value = [...value, newValue]
      } else {
        value = value.filter(v => v.id !== newValue.id)
      }
      this.setState({value})
    } else {
      this.setState({value: newValue}, this.commit)
    }
  }

  commit = () => {
    this.props.onCommit(this.state.value)
  }

  cancel = () => {
    this.props.onCancel()
  }

  render() {
    const {
      open,
      anchor,
      multiSelect,
      commitLabel,
      cancelLabel,
      noneLabel,
      commitButtonWidth,
      cancelButtonWidth,
      noneButtonWidth,
      ...otherProps
    } = this.props
    const {value} = this.state

    const buttons = [
      <Button key="none" label={noneLabel} flat width={noneButtonWidth} onClick={this.none}/>,
      <Button key="cancel" label={cancelLabel} flat width={cancelButtonWidth} onClick={this.cancel}/>,
    ]

    if (multiSelect) {
      buttons.push(
        <Button
          key="commit"
          label={commitLabel}
          primary
          width={commitButtonWidth}
          onClick={this.commit}
        />
      )
    }

    let listValue, subLabel
    if (value && multiSelect) {
      listValue = value.filter(v => v).map(v => v ? v.id : -1)
      if (value.length > 0) {
        subLabel = `${value.length} selected`
      }
    }

    return (
      <BaseEditor
        open={open}
        anchor={anchor}
        {...otherProps}
        padded={false}
        height={400}
        width={450}
        className="contactListEditor"
        onClose={this.cancel}
        onFocus={() => {
        }}
      >
        <div className={getClassName('container')}>
          <ContactListSearcher onSelect={this.change} value={listValue} multiSelect={multiSelect}/>
          <div className={getClassName('subLabel')}>
            {subLabel}
          </div>
          <div className={getClassName('buttons')}>
            {buttons}
          </div>
        </div>
      </BaseEditor>
    )
  }
}

const valueShape = propTypes.shape({
  id: propTypes.number.isRequired,
  label: propTypes.string,
})

ContactListEditor.propTypes = {
  value: propTypes.oneOfType([valueShape, propTypes.arrayOf(valueShape)]),
  multiSelect: propTypes.bool,
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  label: propTypes.string,
  width: propTypes.number,
  commitLabel: propTypes.string,
  cancelLabel: propTypes.string,
  noneLabel: propTypes.string,
  commitButtonWidth: propTypes.number,
  cancelButtonWidth: propTypes.number,
  noneButtonWidth: propTypes.number,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

ContactListEditor.defaultProps = {
  multiSelect: false,
  commitLabel: 'Update',
  cancelLabel: 'Cancel',
  noneLabel: 'Clear',
  commitButtonWidth: 90,
  cancelButtonWidth: 90,
  noneButtonWidth: 90,
}

export default ContactListEditor
